/**
 * Centralized contact information for BlueLux
 * Single source of truth for all contact details across the application
 */

export const contactInfo = {
  phone: {
    display: '601-BLUE-LUX',
    displayWithActual: '601-BLUE-LUX (601-258-3589)',
    actual: '601-258-3589',
    formatted: '+1-601-258-3589',
    tel: '6012583589',
  },
  email: {
    primary: 'team@bluelux.com',
    legal: 'legal@bluelux.com',
  },
  company: {
    name: 'BlueLux',
    legalName: 'BlueLux LLC',
    address: 'PO Box 8831, Rancho Santa Fe, CA 92067',
  },
  hours: {
    weekday: 'Mon-Fri 8AM-6PM',
    saturday: 'Sat 9AM-4PM',
    emergency: '24/7 Emergency Available',
  },
} as const;

/**
 * Pre-formatted SMS messages for WhatsApp links
 */
export const smsTemplates = {
  general: (context?: string) => 
    `Hi! I'm interested in BlueLux pool service${context ? ` - ${context}` : ''}.`,
  promo: (promoName: string) => 
    `Hi! I'm interested in the ${promoName} special offer from BlueLux.`,
  existing: () => 
    `Hi! I'm an existing BlueLux customer and need assistance.`,
  emergency: () => 
    `Hi! I have an urgent pool issue that needs immediate attention.`,
  quote: () => 
    `Hi! I just submitted a quote request and have a question.`,
} as const;

/**
 * Service areas for BlueLux Pool Services
 * Used in Service schema markup across all service pages
 */
export const serviceAreas = [
  "Rancho Santa Fe",
  "Del Mar",
  "La Jolla",
  "Carmel Valley",
  "Fairbanks Ranch",
  "Solana Beach",
  "Encinitas",
  "Cardiff-by-the-Sea",
  "La Costa",
  "4S Ranch",
  "Del Sur",
  "Santaluz",
  "The Crosby",
  "Olivenhain",
  "Rancho Bernardo",
  "Poway",
  "Scripps Ranch",
  "Torrey Highlands"
] as const;
